// src/components/Footer.js
// Website footer — link columns + legal + copyright. Shown on every page.

import Logo from "./Logo";

export default function Footer({ onNavigate, onOpenLegal }) {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Logo size={26} />
          <p>Where ideas become visual stories.</p>
        </div>

        <div className="site-footer__cols">
          <div className="site-footer__col">
            <h5>Create</h5>
            <button onClick={() => onNavigate("image")}>Image Studio</button>
            <button onClick={() => onNavigate("video")}>Video Studio</button>
            <button onClick={() => onNavigate("characters")}>Characters</button>
            <button onClick={() => onNavigate("assistant")}>Assistant</button>
          </div>
          <div className="site-footer__col">
            <h5>Community</h5>
            <button onClick={() => onNavigate("drift")}>Explore Drift</button>
            <button onClick={() => onNavigate("subscribe")}>Pricing</button>
          </div>
          <div className="site-footer__col">
            <h5>Legal</h5>
            <button onClick={() => onOpenLegal("terms")}>Terms</button>
            <button onClick={() => onOpenLegal("privacy")}>Privacy</button>
            <button onClick={() => onOpenLegal("content-policy")}>Content Policy</button>
          </div>
        </div>
      </div>
      <div className="site-footer__bottom">© {year} Karvi AI. All rights reserved.</div>
    </footer>
  );
}
